// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderSummaryCardStyles } from "@conklin/Overrides/Components/OrderSummaryCard";
import IconReorder from "@conklin/XDL/Icons/IconReorder";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, createLinkIconStyles, xScreen } from "@conklin/XDL/Utilities";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

orderSummaryCardStyles.actionsCells = {
    css: css`
        min-width: 70px;
        max-width: 100px;
    `,
};

orderSummaryCardStyles.reorderButton = {
    ...createLinkIconStyles(IconReorder, "small", "left", false, {
        css: css`
            width: 100%;
            &&& {
                ${TypographyStyle} {
                    font-size: 12px;
                    line-height: 15px;
                    display: inline;
                }

                ${xScreen("lte", "md")} {
                    text-align: right;
                }
            }
        `,
    }),
};

orderSummaryCardStyles.reorderButtonSpinner = {
    size: 18,
};

orderSummaryCardStyles.dataCells = {
    css: css`
        ${TypographyStyle} {
            color: ${color("text.main")};
            font-weight: normal;
            &:hover {
                color: ${color("text.main")};
            }
        }

        ${StyledButton} > ${TypographyStyle} {
            color: ${color("text.link")};
        }
    `,
};

orderSummaryCardStyles.orderDateText = {
    size: 14,
    lineHeight: "17px",
    weight: fontConfig.weight.bold,
};
